import React, { useState } from 'react'

import { FeedbackModal } from 'cube/components/FeedbackModal'
import { Route } from 'react-router-dom'

import { Banner, Button, FeatureBadge, Text } from '@driftt/dds'
import { faBullhorn } from '@driftt/dds.icons/light/faBullhorn'

import useLocalStorage from 'hooks/useLocalStorage'
import { RevenueOpportunitiesReport } from 'layouts/RevenueReport/Opportunities'
import { RevenueOverviewReport } from 'layouts/RevenueReport/Overview'

const RevenueReportBetaBanner = () => {
  const [showFeebackModal, setShowFeedbackModal] = useState<boolean>(false)
  const [showBetaBanner, setShowBetaBanner] = useLocalStorage(
    'showRevenueBetaBanner',
    true
  )

  if (!showBetaBanner) {
    return null
  }

  return (
    <>
      <Banner.Root
        variant="beta"
        onClose={() => setShowBetaBanner(false)}
        rootProps={{ id: 'revenue-report--beta-banner' }}
      >
        <Banner.Content>
          <FeatureBadge variant="beta" />
          <Text as="span">
            Welcome to the new <b>Revenue</b> report!
          </Text>
          <Button
            variant="tertiary"
            onClick={() => setShowFeedbackModal(true)}
            rootProps={{
              id: 'revenue-report--beta-banner-feedback-button',
            }}
          >
            <Button.Icon icon={faBullhorn} />
            Give feedback
          </Button>
        </Banner.Content>
      </Banner.Root>
      <FeedbackModal
        open={showFeebackModal}
        onClose={() => setShowFeedbackModal(false)}
        trackingEventName="REVENUE_REPORT_FEEDBACK_SUBMITTED"
      />
    </>
  )
}

export const RevenueReport = () => {
  return (
    <>
      <RevenueReportBetaBanner />
      <Route exact path="/revenue/overview" component={RevenueOverviewReport} />
      <Route
        exact
        path="/revenue/opportunities"
        component={RevenueOpportunitiesReport}
      />
    </>
  )
}
